import React from 'react'
import PropTypes from 'prop-types'

import ConnectMemberCard from '../connect_sections/ConnectMemberCard'
import DashboardSectionShell from './DashboardSectionShell'

function DashboardMatchesSection({ matches, missingImg }) {
  if (!matches || matches.length === 0) {
    return null
  }

  return (
    <DashboardSectionShell
      icon="search"
      title="Your matches"
      subtitle="Connect with language partners near you"
    >
      <div className="dashboardMatchesList" role="list" aria-label="Language matches">
        {matches.map((match) => (
          <ConnectMemberCard
            key={match.id}
            user={match}
            missingImg={missingImg}
            variant="missed"
          />
        ))}
      </div>
      <div className="dashboardHomeSection__footer">
        <button
          type="button"
          className="small_button_secondary"
          onClick={() => window.location.assign('/friends')}
        >
          See all language matches
        </button>
      </div>
    </DashboardSectionShell>
  )
}

DashboardMatchesSection.propTypes = {
  matches: PropTypes.array.isRequired,
  missingImg: PropTypes.string.isRequired,
}

export default DashboardMatchesSection
